// Module
var code = "<div ng-switch=\"vm.serie.type\"> <wt-identifier-icon ng-switch-when=\"0\" type=\"vm.serie.identifierType\"></wt-identifier-icon> <wt-identifier-icon ng-switch-when=\"1\" type=\"vm.serie.identifierType\"></wt-identifier-icon> <i ng-switch-when=\"3\" class=\"fa fa-fw fa-filter\" title=\"{{'Query'|translate}}\"></i> </div>";
// Exports
module.exports = code;